<div class="m-form-field">
  <div class="a-text-field tw-flex">
    <div class="tw-flex empty:tw-hidden">
      <ng-content select="[prefix]"></ng-content>
    </div>

    <div class="tw-w-full">
      <label *ngIf="label" [for]="id"> {{ label }} <ng-container *ngIf="isRequired$ | async">*</ng-container> </label>

      <input
        [id]="id"
        [formControl]="control"
        [placeholder]="placeholder"
        [readonly]="readonly"
        [disabled]="isDisabled$ | async"
        [boschUiInputAutofocus]="autofocus"
        type="text"
      />
    </div>

    <div class="tw-flex empty:tw-hidden">
      <ng-content select="[postfix]"></ng-content>
    </div>
  </div>
  <bosch-ui-validation-error
    *ngIf="!errorRef && (error$ | async) as error"
    [error]="'common.validation.error.' + error | translate"
  ></bosch-ui-validation-error>
  <ng-container *ngIf="errorRef">
    <ng-content></ng-content>
  </ng-container>
</div>
